<template>
  <div id="transfer__list">
    <!-- transfer list table -->
    <div class="vx-card p-6" id="transfer___List">
      <!-- transfer table -->
      <vs-table
        id="table-loading"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="500px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        pagination
        :max-items="length"
        search
        :data="transfers"
      >
        <!-- table header -->
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">
                    {{ page * length - (length - (FilteredCount && 1)) }}
                    -
                    {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                    of {{ FilteredCount }} (filtered from {{ total }} total entries)
                  </span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="handleChangeLength(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div
              @click="AddTransferModalShow = true"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Transfer</span>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th sort-key="paroduct.id">Sr#</vs-th>
          <vs-th sort-key="product.product_name">Created At</vs-th>
          <vs-th sort-key="product.weight_type">Transfer Type</vs-th>
          <vs-th sort-key="product.weight_per_package">Supplier</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              {{ formatDate(tr.created_at) }}
            </vs-td>
            <vs-td>
              {{ tr.transfer_type }}
            </vs-td>
            <vs-td> {{ tr.supplier ? tr.supplier.business_name : parentUser.username }} </vs-td>
            <vs-td
              ><feather-icon class="cursor-pointer p-2" icon="EyeIcon" @click="viewTransferDetailModal(tr.id)" />
              <feather-icon icon="Trash2Icon" class="cursor-pointer p-2" @click="deleteRecord(tr.id)" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- add transfer modal -->
    <add-transfer :showModal.sync="AddTransferModalShow" />

    <!-- view transfer detail -->
    <view-transfer-details v-if="isViewTransferDetailsModalMounted" :showModal.sync="isViewTransferDetailsModalShow" :transferId="currentSelectedTransferId" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import AddTransfer from '@/views/transfers/components/AddTransfer.vue'
import { transferStatus } from '@/utils/enums'
import ViewTransferDetails from './components/ViewTransferDetails.vue'

export default {
  name: 'TransferList',

  components: {
    AddTransfer,
    ViewTransferDetails
  },

  data: () => ({
    AddTransferModalShow: false,
    selectedTransferId: null,
    order: [],
    length: 10,
    page: 1,
    search: '',
    transferStatus,
    isViewTransferDetailsModalMounted: false,
    isViewTransferDetailsModalShow: false,
    currentSelectedTransferId: null,
    loading: false
  }),

  mixins: [dateMixins],

  async mounted() {
    await this.getData()
  },

  computed: {
    ...mapState('transfer', { transfers: 'transfers', total: 'total', FilteredCount: 'FilteredCount' }),
    ...mapState('auth', ['parentUser'])
  },

  methods: {
    ...mapActions('transfer', ['getTransferList', 'syncList']),
    // sync transfer list
    async syncTransfer(syncDate) {
      await this.syncList({
        date: syncDate
      })
    },

    async getData() {
      const { order, length, page, search } = this
      this.getTransferList({
        order,
        limit: length,
        page,
        search
      })
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    // complete transfer
    completeTransfer(data) {
      this.selectedTransferId = data.id
      this.completeTransferModalShow = true
    },

    // delete transfer
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure, you want to delete this record?',
        accept: () => this.deleteTransfer(id),
        acceptText: 'Delete'
      })
    },

    // delete transfer
    deleteTransfer(id) {
      this.loading = true
      this.$store
        .dispatch('transfer/deleteTransfer', id)
        .then(() => {
          this.loading = false
          this.$vs.notify({
            title: 'Success',
            text: 'Transfer deleted successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // view transfer details modal
    viewTransferDetailModal(id) {
      this.isViewTransferDetailsModalMounted = true
      this.isViewTransferDetailsModalShow = true
      this.currentSelectedTransferId = id
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#transfer___List',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#transfer___List > .con-vs-loading')
      }
    },

    isViewTransferDetailsModalShow: {
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isViewTransferDetailsModalMounted = false
            this.currentSelectedTransferId = null
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.AddItemProductModalShow = false
    next()
  }
}
</script>

<style lang="scss" scoped>
.transfer__actions {
  width: 250px;

  li {
    padding: 5px;
    a {
      display: flex !important;
      align-items: center;
    }
  }
}
</style>